<div class="ws-page-header">
  <!-- Icon and Title Section -->
  <div class="header-info">
    <mat-icon *ngIf="icon" class="header-icon">{{ icon }}</mat-icon>
    <div class="title-section">
      <h1 class="title">{{ title }}</h1>
    </div>
  </div>
</div>
